import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {TableComponent} from '../../../components/table/table.component';
import {AuthenticatedBaseComponent} from '../../authenticated-base.component';

@Component({
  selector: 'app-authenticated-inquiries-index',
  templateUrl: './index.component.html',
  imports: [TableComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IndexComponent extends AuthenticatedBaseComponent implements OnInit {
  public ngOnInit() {
    this.titleService.setTitle('authenticated.inquiries.index.title');
  }
}
